import axios from "axios";

// Same-origin in production (REACT_APP_API_URL is empty — the backend sits
// behind a reverse proxy on the same domain), explicit host in development.
export const API_BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:8080";

// Absolute origin of the public site, used for canonical/OG URLs and sitemap
// generation (REACT_APP_FRONT_URL is empty in production — see .env.production).
export const SITE_URL = process.env.REACT_APP_FRONT_URL || "https://saydalani.com";

const api = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`,
    headers: {
        "Content-Type": "application/json",
    },
});

export default api;
